var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicMute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6265 24.4278L12.6512 16.0371L10.3899 13.7758V19.8185C9.79794 19.4602 9.14176 19.2377 8.43742 19.2377C6.11426 19.2377 4.22354 21.425 4.22354 24.1065C4.22354 26.8004 6.1142 28.9753 8.43742 28.9753C10.674 28.9753 12.4782 26.9611 12.6265 24.4278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5628 14.3811C22.0676 14.3811 20.7565 15.2832 20.0162 16.6302L26.3061 22.9201C27.2082 22.0304 27.7766 20.7082 27.7766 19.2376V3.02472L10.3898 5.61977V7.00382L14.7409 11.3536L25.5042 9.84602V14.9496C24.9221 14.6036 24.2672 14.3811 23.5628 14.3811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5219 17.8783L13.2196 11.5761L10.3898 8.74619L4.64357 3L3 4.64357L10.3898 12.0333L12.6511 14.2947L19.8184 21.462L22.1911 23.8346L27.3564 29L29 27.3564L25.3051 23.6616L19.5219 17.8783Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicMute);
export default __webpack_public_path__ + "static/media/music-mute.bcac97031dc3ce34345eca08709b95ba.svg";
export { ForwardRef as ReactComponent };